<div class="container" *ngIf="mostraAlerta;" [hidden]="alertasNaoVisto.length == 0">
  <div class="filtro filtro-peq d-flex align-items-center btn-hover" data-bs-toggle="modal"  data-bs-target="#modalAlertas" >
    <div class="alerta">
      <div class="pop-up-qtd">
        {{ alertasNaoVisto.length }}
      </div>
      <button [hidden]="true" (click)="marcaComoVisualizado()" #marcarAlertaVisualizado id="marcarAlertaVisualizado"></button>
    <img class="ms-2" src="assets/img/alerta-2.svg" alt="">
    </div>
</div>
<audio [muted]="silenciado" autoplay>
  <source src="assets/som/alerta.mp3" type="audio/mp3" />
</audio>
</div>

<ng-template #notificacoes>
<div class="container">
  <div class="filtro d-flex align-items-center" >
    <div class="alerta">
      <div class="pop-up-qtd">
        {{ alertasNaoVisto.length }}
      </div>
      <img class="ms-2" src="assets/img/alerta-2.svg" alt="">
    </div>
    <div class="w-100 d-flex justify-content-between">
      <span class="ms-4">Alertas não vistos</span>
      <div>
        <button [disabled]="isUpdating" class="btn btn-primary btn-sm me-4" style="margin-top: -4px;" (click)="marcaComoVisualizado()">Marca como visualizado(s)
          <img *ngIf="isUpdating" style="margin-top: -4px; margin-left: 5px; max-width: 16px;" src='assets/img/loading.gif' alt="Carregando...">
        </button>
        <img class="justify-content-end btn-hover" src="assets/img/chevron-right.svg" alt="" (click)="alteraMostraAlerta(true)">
      </div>
    </div>

  </div>

  <div class="box">
    <div  *ngFor="let item of alertasNaoVisto">
      <app-alerta-card-notificacao
        [roteiroAlerta]="item"
        (abrirModalMapa)="abrirMapa($event)"
      >
      </app-alerta-card-notificacao>
    </div>
  </div>

</div>

</ng-template>
